import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
interface DisputesPanelProps {
  disputesPct: number;
  phase: number;
  isRecomputing?: boolean;
}
export function DisputesPanel({
  disputesPct,
  phase,
  isRecomputing
}: DisputesPanelProps) {
  const categories = [{
    label: 'Pricing issues',
    value: 1.2,
    color: 'bg-amber-500'
  }, {
    label: 'Quality disputes',
    value: 0.6,
    color: 'bg-orange-500'
  }, {
    label: 'Delivery timing',
    value: 0.3,
    color: 'bg-red-500'
  }];
  return <div className={`bg-slate-900 border rounded p-3.5 h-full transition-colors ${isRecomputing ? 'border-emerald-500/50' : 'border-slate-800'}`} data-id="element-135">
      <div className="flex items-center justify-between mb-3 pt-2" data-id="element-136">
        <h3 className="text-base font-semibold text-slate-300 tracking-tight" data-id="element-137">
          Disputes & Dilution
        </h3>
        <AlertTriangleIcon size={16} className="text-slate-600" data-id="element-138" />
      </div>

      <div className="mb-3" data-id="element-139">
        <div className="text-[10px] text-slate-500 uppercase tracking-wide mb-1" data-id="element-140">
          Disputed Value
        </div>
        <motion.div key={disputesPct} initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: phase >= 3 ? 1 : 0,
        scale: phase >= 3 ? 1 : 0.95
      }} transition={{
        duration: 0.2
      }} className={`text-[32px] font-mono font-semibold leading-none ${isRecomputing ? 'text-emerald-400' : 'text-amber-400'}`} data-id="element-141">
          <motion.span animate={{
          scale: isRecomputing || phase >= 8 ? [1, 1.08, 1] : 1
        }} transition={{
          duration: 0.4
        }} data-id="element-142">
            {disputesPct > 0 ? `${disputesPct.toFixed(1)}%` : '—'}
          </motion.span>
        </motion.div>
      </div>

      {disputesPct > 0 && phase >= 3 && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.15,
      duration: 0.2
    }} className="space-y-2.5" data-id="element-143">
          <div className="text-[10px] text-slate-500 uppercase tracking-wide mb-1.5" data-id="element-144">
            Categories
          </div>
          {categories.map((category, index) => <motion.div key={category.label} initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.2 + index * 0.05,
        duration: 0.2
      }} data-id="element-145">
              <div className="flex items-center justify-between text-[11px] mb-1.5" data-id="element-146">
                <span className="text-slate-400" data-id="element-147">{category.label}</span>
                <span className="font-mono font-semibold text-slate-300 text-[12px]" data-id="element-148">
                  {category.value.toFixed(1)}%
                </span>
              </div>
              <div className="h-2 bg-slate-800 rounded-full overflow-hidden" data-id="element-149">
                <motion.div initial={{
            width: 0
          }} animate={{
            width: `${category.value / disputesPct * 100}%`
          }} transition={{
            duration: 0.3,
            delay: 0.2 + index * 0.05
          }} className={`h-full ${category.color}`} data-id="element-150" />
              </div>
            </motion.div>)}
        </motion.div>}

      {disputesPct > 0 && phase >= 3 && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.4,
      duration: 0.2
    }} className="mt-3 pt-3 border-t border-slate-800" data-id="element-151">
          <div className="text-[9px] text-slate-400" data-id="element-152">
            {phase >= 8 ? 'Dispute resolved. Within tolerance band.' : 'Within internal tolerance band.'}
          </div>
        </motion.div>}
    </div>;
}